import React from 'react'
import TagFacet from 'ui-shared/Facets/Wrappers/FacetTag'
import SkillFacetInput from '../Wrappers/SkillFacetInput'

const ExperienceFacetSection = () => {
  return (
    <>
      <TagFacet />
      <SkillFacetInput />
    </>
  )
}

export default ExperienceFacetSection
